import AsyncLoader from 'component/AsyncLoader';

export const ServiceNotice =  AsyncLoader(() => import('./ServiceNotice'));